import styled from 'styled-components';

export const FiltersChevron = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  color: ${({ theme }) => theme.colors.text.secondary};
  transition: transform 0.2s ease;
`;

export const FiltersDetails = styled.details`
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  background-color: ${({ theme }) => theme.colors.background};

  &[open] ${FiltersChevron} {
    transform: rotate(180deg);
  }
`;

export const FiltersSummary = styled.summary`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.45rem 0.6rem;
  font-size: 0.78rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  cursor: pointer;
  list-style: none;
  user-select: none;
  transition: background-color 0.2s ease;

  &::-webkit-details-marker {
    display: none;
  }

  &:hover {
    background-color: ${({ theme }) => `${theme.colors.primary}08`};
  }
`;

export const FiltersSummaryText = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FiltersBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding: 0 0.5rem 0.5rem;
  border-top: 1px solid ${({ theme }) => theme.colors.border.light};
`;

export const CompactFilterRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem;
`;

export const CompactFilterLabel = styled.span`
  flex-shrink: 0;
  width: 3.1rem;
  font-size: 0.7rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const CompactFilterChip = styled.button<{ $isActive: boolean }>`
  display: inline-flex;
  align-items: center;
  padding: 0.16rem 0.45rem;
  font-size: 0.7rem;
  font-weight: ${({ $isActive }) => ($isActive ? 600 : 500)};
  line-height: 1.25;
  color: ${({ theme, $isActive }) =>
    $isActive ? theme.colors.text.primary : theme.colors.text.secondary};
  background-color: ${({ theme, $isActive }) =>
    $isActive ? `${theme.colors.primary}12` : 'transparent'};
  border: 1px solid
    ${({ theme, $isActive }) =>
      $isActive ? `${theme.colors.primary}28` : theme.colors.border.light};
  border-radius: 999px;
  cursor: pointer;
  white-space: nowrap;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease;

  &:hover {
    background-color: ${({ theme }) => `${theme.colors.primary}08`};
    border-color: ${({ theme }) => `${theme.colors.primary}22`};
    color: ${({ theme }) => theme.colors.text.primary};
  }
`;
